import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 20c8 0 18 -16 18 -16","key":"svg-0"}]]

const IconEaseIn = createReactComponent('outline', 'ease-in', 'EaseIn', __iconNode);

export default IconEaseIn;